// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/sudoku-board.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.problem-container {
    height: 100vh;
    width: 100vw;
    display: grid;
    grid-template: 1fr / 1fr 10fr;
}

.problem-container div {
    /* border: 1px solid red; */
}
.sudoku-container {
    display: flex;
    align-items: center;
    flex-direction: column;
}
.sudoku-container #sudoku-modifier{
    margin-top: 1em;
    left: 50%;
    position: absolute;
    transform: translate(-50%);
}
.sudoku-container #status {
    margin-top: 2em;
    left: 50%;
    top: 6%;
    position: absolute;
    transform: translate(-50%, -6%);
}
.board-container div {
    width: 5rem;
    height: 5rem; 
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2em;
}

.board-container {
    display: grid;
    grid-template: repeat(9, 1fr) / repeat(9, 1fr);
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
}

.n-queens-container #picker-and-board, .n-knights-container #picker-and-board{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 2em;
}

#queen-board, #knight-board {
   width: 70%;
   height: 70%;
   display: flex;
   flex-wrap: wrap;
   justify-content: center;
   background-image: url("http://www.wood-database.com/wp-content/uploads/bamboo-qs-sealed.jpg");
   padding: 1.5em;
   background-repeat: no-repeat;
   background-size: cover;
   box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}


#queen-board div, #knight-board div {
    font-size: 3em;
    width: 100%;
    height: 100%; 
    display: flex;
    align-items: center;
    justify-content: center;
}

#solved-board-div {
    background-image: url("http://www.wood-database.com/wp-content/uploads/bamboo-qs-sealed.jpg");
    width: 80%;
}


#solved-board-div div   {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2em;
}

#solved-boards, #knight-solved-boards {
    overflow: auto;
    box-shadow: -5px 0 5px -5px #333;
    width: 100%; 
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.word-search-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}


#search-board {
    display: grid;
    grid-template: repeat(12, 1fr) / repeat(12, 1fr);
    grid-template-rows: auto;
    width: 80%;
    height: 80%;
}
#board-controls {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 1em;
    gap: 1em;
}

#select-problem {
    padding: 1em;
    margin: 1em;
    border: none;
    background-color: rgb(236, 236, 236);
}

#board-controls button,
.n-queens-container #picker-and-board button, 
.n-knights-container #picker-and-board button,
#sudoku-modifier button {
    border: none;
    background-color: rgb(35, 98, 233);
    color: white;
    padding: 1em;
    border-radius: 1em;
}

#board-controls input, #board-controls select,
.n-queens-container #picker-and-board select, 
.n-knights-container #picker-and-board select,
#sudoku-modifier select {
    border: none;
    padding: 1em;
    background-color: rgb(236, 236, 236);
    border-radius: 1em;
}
#search-board div {
    border: 1px solid rgb(202, 201, 201);
    display: flex;
    align-items: center;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;AACA;IACI,4DAA4D;AAChE;AACA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8CAA8C;IAC9C,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,yDAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;GACG,UAAU;GACV,WAAW;GACX,aAAa;GACb,eAAe;GACf,uBAAuB;GACvB,6FAA6F;GAC7F,cAAc;GACd,4BAA4B;GAC5B,sBAAsB;GACtB,4EAA4E;AAC/E;;;AAGA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6FAA6F;IAC7F,UAAU;AACd;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,gDAAgD;IAChD,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA;;;;IAII,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;;;IAII,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;AACtB;AACA;IACI,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\nbody {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.problem-container {\n    height: 100vh;\n    width: 100vw;\n    display: grid;\n    grid-template: 1fr / 1fr 10fr;\n}\n\n.problem-container div {\n    /* border: 1px solid red; */\n}\n.sudoku-container {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n}\n.sudoku-container #sudoku-modifier{\n    margin-top: 1em;\n    left: 50%;\n    position: absolute;\n    transform: translate(-50%);\n}\n.sudoku-container #status {\n    margin-top: 2em;\n    left: 50%;\n    top: 6%;\n    position: absolute;\n    transform: translate(-50%, -6%);\n}\n.board-container div {\n    width: 5rem;\n    height: 5rem; \n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 2em;\n}\n\n.board-container {\n    display: grid;\n    grid-template: repeat(9, 1fr) / repeat(9, 1fr);\n    top: 50%;\n    left: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n    background-image: url(\"images/sudoku-board.jpg\");\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.n-queens-container #picker-and-board, .n-knights-container #picker-and-board{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 2em;\n}\n\n#queen-board, #knight-board {\n   width: 70%;\n   height: 70%;\n   display: flex;\n   flex-wrap: wrap;\n   justify-content: center;\n   background-image: url(\"http://www.wood-database.com/wp-content/uploads/bamboo-qs-sealed.jpg\");\n   padding: 1.5em;\n   background-repeat: no-repeat;\n   background-size: cover;\n   box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n}\n\n\n#queen-board div, #knight-board div {\n    font-size: 3em;\n    width: 100%;\n    height: 100%; \n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n#solved-board-div {\n    background-image: url(\"http://www.wood-database.com/wp-content/uploads/bamboo-qs-sealed.jpg\");\n    width: 80%;\n}\n\n\n#solved-board-div div   {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 2em;\n}\n\n#solved-boards, #knight-solved-boards {\n    overflow: auto;\n    box-shadow: -5px 0 5px -5px #333;\n    width: 100%; \n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.word-search-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n\n#search-board {\n    display: grid;\n    grid-template: repeat(12, 1fr) / repeat(12, 1fr);\n    grid-template-rows: auto;\n    width: 80%;\n    height: 80%;\n}\n#board-controls {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 1em;\n    gap: 1em;\n}\n\n#select-problem {\n    padding: 1em;\n    margin: 1em;\n    border: none;\n    background-color: rgb(236, 236, 236);\n}\n\n#board-controls button,\n.n-queens-container #picker-and-board button, \n.n-knights-container #picker-and-board button,\n#sudoku-modifier button {\n    border: none;\n    background-color: rgb(35, 98, 233);\n    color: white;\n    padding: 1em;\n    border-radius: 1em;\n}\n\n#board-controls input, #board-controls select,\n.n-queens-container #picker-and-board select, \n.n-knights-container #picker-and-board select,\n#sudoku-modifier select {\n    border: none;\n    padding: 1em;\n    background-color: rgb(236, 236, 236);\n    border-radius: 1em;\n}\n#search-board div {\n    border: 1px solid rgb(202, 201, 201);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
